import React from "react";
import FluidImage from "../../../components/fluidImage";
import Link from "../../../utils/link";
import Video from "../../../components/video";

const WorkpageCard = (props) => {

    const hasVideo = props.video?.filename != undefined && props.video?.filename != ""


    return(
        <div className="text-xs lg:text-lg space-y-3 lg:space-y-5 group relative">
            <div className={`overflow-hidden ${props.mobileLandscape ? `aspect-[335/447]` : `aspect-[335/253]`} lg:aspect-[700/500]`}>
                {
                    hasVideo ? (
                        <Video video={props.video} poster={props.image} className='group-hover:scale-[102%] transition-transform duration-500 w-full h-full object-cover'/>
                    ):
                    (
                        <FluidImage image={props.image} className='group-hover:scale-[102%] transition-transform duration-500 w-full h-full object-cover'/>
                    )
                }
            </div>
            <div className="flex lg:block justify-between">
                <h2 className="font-semibold">{props.title}</h2>
                <p>
                    {props.copy}
                </p>
            </div>
            <Link to={props.url} className='absolute inset-0 z-10'>
                <span className="sr-only">Read {props.title}</span>
            </Link>
        </div>
    )
}

export default WorkpageCard;